import { render, staticRenderFns } from "./AddEditNode.vue?vue&type=template&id=24c938fc"
import script from "./AddEditNode.vue?vue&type=script&lang=js"
export * from "./AddEditNode.vue?vue&type=script&lang=js"
import style0 from "./AddEditNode.vue?vue&type=style&index=0&id=24c938fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports